import { render, staticRenderFns } from "./Sampled.vue?vue&type=template&id=5813d02e&scoped=true"
import script from "./Sampled.vue?vue&type=script&lang=js"
export * from "./Sampled.vue?vue&type=script&lang=js"
import style0 from "./Sampled.vue?vue&type=style&index=0&id=5813d02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5813d02e",
  null
  
)

export default component.exports